const getKey = (id) => {
  return id ? id : "btn-" + Math.floor(Math.random() * 100 + 1);
};

const getVariant = (variant) => {
  let bg = "bg-gray-200";
  switch (variant) {
    case "success": {
      bg = "bg-green-700 text-darkTextPrimary";
      break;
    }
    case "danger": {
      bg = "bg-red-700 text-darkTextPrimary";
      break;
    }
    case "primary": {
      bg = "bg-blue-700 text-darkTextPrimary";
      break;
    }
    case "secondary": {
      bg = "bg-gray-700 text-darkTextPrimary";
      break;
    }
    case "warning": {
      bg = "bg-yellow-500 text-darkTextPrimary";
      break;
    }
    case "normal": {
      bg = "bg-gray-300 text-darkTextPrimary";
      break;
    }
  }

  return bg;
};

const getRounded = (rounded) => {
  if (rounded) {
    return rounded;
  }
  return "rounded-md";
};

const getBadge = (num) => {
  if (!num) {
    return null;
  }
  return (
    <div
      className="absolute inline-flex items-center justify-center w-6 h-6 text-xs 
          font-bold text-white bg-red-500 border-2 border-white -top-2 -right-2
        dark:border-gray-900"
    >
      {num}
    </div>
  );
};

const Button = (props) => {
  return (
    <button
      id={props.id}
      key={getKey(props.id)}
      className={` inline-flex 
          items-center font-bold text-sm justify-center
          ${props.padding ? props.padding : "p-4"}
          ${props.badgeNum ? "relative" : ""}
          ${props.extraClass}
          ${getRounded(props.rounded)}
          ${getVariant(props.variant)}`}
      onClick={props.onClick}
    >
      {props.icon ? props.icon : null}
      <span className={props.icon !== undefined ? "mr-2" : ""}>
        {props.content}
      </span>
      {getBadge(props.badgeNum)}
    </button>
  );
};

export default Button;
